// Module
var code = "<div class=form-group> <label><%= searchLabel %></label> <div class=big-select> <span class=big-select-wrap> <ul> <li><input type=text size=15 placeholder=\"Click to search\" class=big-select-input /></li> </ul> </span> <div class=big-select-options style=display:none> <ul></ul> </div> </div> </div> ";
// Exports
module.exports = code;